import {commonPromise} from '../../http'
import {
    COURSE_LIST,
    SUB_COURSE_LIST,
    COURSE_DETAIL,
    SUB_COURSE,
    LIST,
    VIEW,
    GET_VIDEO,
    LIKE,
    DISLIKE,
    CREATE,
    GET_OUTCONTENT,
    BUY_BROWSE,
    CREATE_ASSISTANCE,
    POST_ASSISTANCE_ID,
    ASSISTANCE_ID_LIST,
    ASSISTANCE_POSTER,
    WECHAT_INFO,
    JAVA_IS_ATTEND,
    SHARE_BILL,
    SHARE_BILL_PRICE,
    POST_VIDEOTIME,
    JAVA_PLACE_ZDM,
    RECORD_LOG,
    INTRODUCE
} from '../global'


export const courseListFetch = (data) => commonPromise(data, COURSE_LIST);// 课程列表
export const introduce = (data) => commonPromise(data, INTRODUCE);// 详情长图
export const subCourseListFetch = (data) => commonPromise(data, SUB_COURSE_LIST);// 子课程列表
export const courseDetailFetch = (data) => commonPromise(data, COURSE_DETAIL);// 课程详情
export const subCourseDetailFetch = (data) => commonPromise(data, SUB_COURSE);// 子课程详情
export const listFetch = (data) => commonPromise(data, LIST);// 获取评论列表
export const viewFetch = (data) => commonPromise(data, VIEW);// 观看视频
export const getVideoFetch = (data) => commonPromise(data, GET_VIDEO);// 获取视频
export const postVideoTime = (data) => commonPromise(data, POST_VIDEOTIME, 'post');// 提交视频已观看时间
export const recordLog = (data) => commonPromise(data, RECORD_LOG, 'post');// 提交异常观看数据
export const likeFetch = (data) => commonPromise(data, LIKE, 'post');// 点赞评论
export const dislikeFetch = (data) => commonPromise(data, DISLIKE, 'post');// 取消点赞评论
export const createFetch = (data) => commonPromise(data, CREATE, 'post');// 发表评论
export const getOutContentFetch = (data) => commonPromise(data, GET_OUTCONTENT);// 获取外链文本
export const buyBrowse = (data) => commonPromise(data, BUY_BROWSE);// 获取外链文本
export const createAssistance = (data) => commonPromise(data, CREATE_ASSISTANCE, 'post');// 发起助力
export const postAssistanceId = (data) => commonPromise(data, POST_ASSISTANCE_ID, 'post')// 助力ID
export const getAssistanceList = (data) => commonPromise(data, ASSISTANCE_ID_LIST)// 获取助力ID列表
export const getAssistancePoster = (data) => commonPromise(data, ASSISTANCE_POSTER)// 获取助力海报
export const getUserInfo = (data) => commonPromise(data, WECHAT_INFO)// 获取用户信息
// 发起（POST）http://api.museum.com/wechat/assistance/initiate?item_id=课程ID
// 助力（POST）http://api.museum.com/wechat/assistance/assist?assistance_id=助力ID
// 列表（GET）http://api.museum.com/wechat/assistance/list?assistance_id=助力ID
// 海报（GET）http://api.museum.com/wechat/assistance/get_share_poster?assistance_id=助力ID
export const courseIsAttendDetailFetch = (data) => commonPromise(data, JAVA_IS_ATTEND);// 课程详情
export const shareBill = (data) => commonPromise(data, SHARE_BILL);// 获取分享海报
export const shareBillPrice = (data) => commonPromise(data, SHARE_BILL_PRICE);// 分享按钮曝光次数
export const placeZdm = (data) => commonPromise(data, JAVA_PLACE_ZDM);// 提交值得买log




// WEBPACK FOOTER //
// ./src/api/apiModules/lessonApi.js